// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vt_a bhc_b"};